// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2GG1V","title":"ClientInsurance_title__1gW4g","itemText":"ClientInsurance_itemText__5qmnR"};